import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  resultsSection: {
    flexDirection: 'row',
    height: 'calc(100% - 100px)',
    marginBottom: '-40px',
    [Theme.breakpoints.up('lg')]: {
      paddingLeft: '25px',
    },
  },
  resultsHeader: {},
  selectFlightHeader: {
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[9],
    lineHeight: '150%',
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[7],
    },
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[6],
    },
  },
  descriptionFlightHeader: {
    color: Theme.palette.gray[750],
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[3],
    lineHeight: '145%',
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[2],
    },
  },
  resultsContent: {},
  resultsFilterMenu: {
    display: 'none',
    [Theme.breakpoints.down('md')]: {
      display: 'inline-flex',
      flexGrow: '1',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    '& > button': {
      margin: '0',
    },
  },
  openFiltersButton: {
    color: Theme.palette.gray[750],
    lineHeight: '150%',
    fontSize: Theme.typography.size[2],
  },
  resultsFilterMenuIcon: {
    color: Theme.palette.primary.light,
    marginLeft: '0 !important',
    marginRight: '9px',
    height: '26px !important',
    width: '26px',
  },
  resultsActions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  resultsFlightsNumber: {
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[3],
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '32px',
    color: Theme.palette.gray[750],
  },
  resultsSorting: {
    float: 'right',
    color: Theme.palette.gray[750],
    fontSize: Theme.typography.size[2],
    lineHeight: '150%',
    marginRight: '0',
    marginLeft: 'auto',
    [Theme.breakpoints.down('md')]: {
      marginLeft: '20px',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  sortingDropdown: {
    display: 'inline-block',

    '& > div > button': {
      margin: '0',
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
      color: Theme.palette.primary.light,
    },
  },
  formatedDate: {
    color: Theme.palette.gray[750],
    textTransform: 'capitalize',
    marginBottom: '22px',
    fontSize: Theme.typography.size[3],
    lineHeight: '150%',
    fontFamily: Theme.typography.base.semiBold,
  },
  mobileBar: {
    display: 'none',
    [Theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'row',
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      backgroundColor: '#fff',
      borderTop: `1px solid ${Theme.palette.gray[250]}`,
      padding: '12px 16px',
      gap: '0',
    },
  },
  mobileBarBtn: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    border: `1px solid ${Theme.palette.primary.light}`,
    borderRadius: '4px',
    backgroundColor: '#fff',
    padding: '10px 16px',
    cursor: 'pointer',
    fontSize: Theme.typography.size[2],
    color: Theme.palette.primary.light,
    fontFamily: Theme.typography.base.semiBold,
    fontWeight: 600,
  },
  mobileBarDivider: {
    width: '12px',
    flexShrink: 0,
  },
  mobileBarSortWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    border: `1px solid ${Theme.palette.primary.light}`,
    borderRadius: '4px',
    padding: '0 16px',
  },
  mobileBarIcon: {
    fontSize: '18px',
    color: Theme.palette.primary.light,
    flexShrink: 0,
  },
  mobileBarSortDropdown: {
    flex: 1,
    '& > div > button': {
      margin: 0,
      padding: 0,
      fontSize: Theme.typography.size[2],
      color: Theme.palette.primary.light,
      fontFamily: Theme.typography.base.semiBold,
      fontWeight: 600,
    },
  },
}));

export default useStyles;
